export const API = {
  LOGOUT: {
    path: '/auth/logout',
    method: 'POST',
  },
  GET_CURRENT_USER: {
    path: '/auth/profile',
    method: 'GET',
  },
  GET_CHAT_SESSIONS: {
    path: '/chat-sessions',
    method: 'POST',
  },
  DELETE_CHAT_SESSION: {
    path: '/chat-sessions/:id',
    method: 'DELETE',
  },
  GET_CHAT_SESSION: {
    path: '/chat-sessions/:id',
    method: 'GET',
  },
  CONNECT_USER: {
    path: '/auth/connect',
    method: 'POST',
  },
};

export const PRODUCTS = {
  MENUTIGER: 'MENUTIGER',
  QRTIGER: 'QRTIGER',
};

export const ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};
